import React, { useState, useEffect } from 'react';
import { Button, Dialog, makeStyles } from '@material-ui/core';
import axios from "axios";
import { Error } from '@material-ui/icons';

const PDFViewerButton = (props) => {
    const classes = useStyles();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [blobUrl, setBlobUrl] = useState(null);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, [blobUrl]);

    const downloadAndOpenPDF = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios({
                method: 'POST',
                url: props.api,
                data: props.searchParams,
                responseType: 'blob',
            });
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

            const newBlobUrl = URL.createObjectURL(pdfBlob);
            setBlobUrl(newBlobUrl);

            window.open(newBlobUrl, '_blank');
        } catch (err) {
            setError(err.message);
            setIsError(true);
            console.error('Failed downloading PDF:', err);
        } finally {
            setLoading(false);
        }
    };

    const closeErrorDialog = () => { setIsError(false) };

    return (
        <div className="space-y-4">
            <Button
                onClick={downloadAndOpenPDF}
                disabled={loading}
                className={classes.btnRoot}
            >
                {loading ? 'Please wait ...' : props?.label ? props.label : 'Open PDF'}
            </Button>

            <Dialog
                open={isError}
                onClose={closeErrorDialog}
                PaperProps={{
                    className: classes.dialogPaper,
                }}
            >
                <div className="ticket-delivery-card flex-box align-items-center">
                    <span className="dialog-close-button" onClick={closeErrorDialog}>x</span>
                    <div className="form-element ticket-col">
                        <Error/>
                        <p>Failed to download PDF: {error}</p>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default PDFViewerButton;

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        "& .ticket-delivery-card": {
            position: "relative"
        },
        "& button, .dialog-close-button": {
            cursor: "pointer"
        },
        "& .dialog-close-button": {
            position: "absolute",
            top: 0,
            right: 0,
            height: 20,
            width: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        "& .form-element": {
            padding: "30px 20px",
            textAlign: "center",
            "& p": {
                fontSize: 12,
                marginTop: 15,
                fontWeight: 500
            },
            "& .MuiSvgIcon-root": {
                color: theme.palette.primary.danger,
                width: 40,
                height: 40
            }
        }
    },
    btnRoot: {
        float: "right",
        boxShadow: `0 2px 2px 0 rgba(248, 150, 5, 0.14), 0 3px 1px -2px rgba(248, 150, 5, 0.2), 0 1px 5px 0 rgba(248, 150, 5, 0.12)`,
        textTransform: "uppercase",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        margin: "0.3125rem 1px 0.3125rem 2px",
        padding: "10px 30px",
        fontSize: 12,
        textAlign: "center",
        transition: "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        fontWeight: 400,
        lineHeight: 1.42857143,
        whiteSpace: "nowrap",
        willChange: "box-shadow, transform",
        touchAction: "manipulation",
        borderRadius: 3,
        verticalAlign: "middle",
        width: 177,
        height: 41,
        "&:hover": {
            backgroundColor: `${theme.palette.primary.contrastText} !important`,
            color: `${theme.palette.primary.main} !important`,
            boxShadow: `0 14px 26px -12px rgba(248, 150, 5, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(248, 150, 5, 0.2)`,
        },
        "&:focus": {
            backgroundColor: `${theme.palette.primary.contrastText} !important`,
            color: `${theme.palette.primary.main} !important`,
            boxShadow: `0 14px 26px -12px rgba(248, 150, 5, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(248, 150, 5, 0.2)`,
        },
        "& img": {
            height: 12,
            marginBottom: 1
        },
    }
}));
